import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import StorageService from '../services/StorageService';
import AuthHttpService from '../api/AuthHttpService';

const withAuthAdmin = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        const [isAuthorized, setIsAuthorized] = useState(false);
        const [isLoading, setIsLoading] = useState(true);

        useEffect(() => {
            const checkAuth = async () => {
                const auth = StorageService.getAuth();

                if (!auth?.token) {
                    navigate('/');
                    return;
                }

                try {
                    await AuthHttpService.checkLoggedUser(auth.token);
                    setIsAuthorized(true);
                } catch (error) {
                    console.error('Auth check failed:', error);
                    navigate('/');
                } finally {
                    setIsLoading(false);
                }
            };

            checkAuth();
        }, [navigate]);

        if (isLoading) {
            return null;
        }

        return isAuthorized ? <WrappedComponent {...props} /> : null;
    };
};

export default withAuthAdmin;
